import { slugify } from "$lib/utils/helpers/slugify";

type CrumbItem = {
    label: string;
    class?: string;
    url?: string | null;
};

function getResourceUrlFromMeta(resource: string, meta: DescriptionMetadata): string | null {
    if (!meta.context) return null;

    const resourceContext = meta.context.find(item => item.resource === resource);

    if (!resourceContext) return null;

    const resourceSlug = resourceContext.slug || slugify(resourceContext.label);

    switch (resource) {
        case 'artigo':
            // eslint-disable-next-line no-case-declarations
            const categoryContext = meta.context.find(item => item.resource === 'categoria');

            return `/artigos/${categoryContext ? slugify(categoryContext.label) : ''}/${resourceSlug}`;
        case 'categoria':
            return `/artigos${resourceSlug !== 'home' ? '/' + resourceSlug : ''}`
        case 'sub-categoria':
            return null;
        // return `${getResourceUrlFromMeta('categoria', meta)}/${resourceSlug}`;
        default:
            return null;
    }
}

export type { CrumbItem };

export { getResourceUrlFromMeta };